export const TOPIC_NAME_MAX_LENGTH = 63;
export const TOPIC_DESCRIPTION_MAX_LENGTH = 255;
